import { BaseConfig } from "../config.interface";

interface IToggleButtonConfig {
    color?: string;
    checkedLabel?: string;
    uncheckedLabel?: string;
}


export class ToggleButtonConfig extends BaseConfig<IToggleButtonConfig> implements IToggleButtonConfig {
    /**
     * @deprecated Currently not used
     * @ignore
     */
    color?: string;
    /**
     * Label if the element is active
     */
    checkedLabel?: string;

    /**
     * Label if the element is inactive
     */
    uncheckedLabel?: string;

    /**
     * This is the base theme.
     * @theme Base
     */
    static baseTheme = {
        /**
         * Default configuration.
         */
        Default: new ToggleButtonConfig({
            color:          'primary',
            checkedLabel:   "Aktiv",
            uncheckedLabel: "Inaktiv",
        }),
    };
}
